import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { useRelevanceAlgo } from '../../composables/useRelevanceAlgo'

import translations from './Sort.translations'

type RateSortOption =
  | '-relevance'
  | '-relevance_alt'
  | '-created_at'
  | '-global_rate'
  | 'global_rate'
  | '-vote_count'

export function getSortOptions() {
  const i18n = useI18n()

  const defaultOption = useRelevanceAlgo().orderBy

  const list: Array<{
    label: string
    value: RateSortOption
  }> = [
    {
      label: i18n(translations.relevance),
      value: defaultOption,
    },
    {
      label: i18n(translations.mostHelpful),
      value: '-vote_count',
    },
    {
      label: i18n(translations.recentReviews),
      value: '-created_at',
    },
    {
      label: i18n(translations.rateDescending),
      value: '-global_rate',
    },
    {
      label: i18n(translations.rateAscending),
      value: 'global_rate',
    },
  ]

  return {
    list,
    defaultOption,
  }
}
